import { createContext, Dispatch } from 'react';
import { AlarmsAcknowledgeType, AlarmsFilterOptionsModel } from '@shared/models';

export const AlarmsReducerDefaultValues = {
  conditionFilter: null as string,
  filter: AlarmsAcknowledgeType.All,
  showSystemAlarms: false as boolean,
  filterOptions: {
    conditions: [],
  } as AlarmsFilterOptionsModel,
};

export enum AlarmsActionType {
  SetChannel = 'SetChannel',
  SetCondition = 'SetCondition',
  SetAcknowledge = 'SetAcknowledge',
  SetShowSystemAlarms = 'SetShowSystemAlarms',
  SetFilterOptions = 'SetFilterOptions',
}

type State = typeof AlarmsReducerDefaultValues;
type Action = {
  type: AlarmsActionType;
  payload: boolean | string | AlarmsFilterOptionsModel | AlarmsAcknowledgeType;
};

export const alarmsReducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case AlarmsActionType.SetCondition:
      return { ...state, conditionFilter: payload as string };
    case AlarmsActionType.SetAcknowledge:
      return { ...state, filter: payload as AlarmsAcknowledgeType };
    case AlarmsActionType.SetShowSystemAlarms:
      return { ...state, showSystemAlarms: payload as boolean };
    case AlarmsActionType.SetFilterOptions:
      return { ...state, filterOptions: payload as AlarmsFilterOptionsModel };
    default:
      return state;
  }
};

export const AlarmsContext = createContext<{
  state?: State;
  dispatch?: Dispatch<Action>;
}>({});
